






import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class TabComponent extends Vue {
    @Prop() title!: string;
    @Prop() subtitle!: string;

    private isActive: boolean = true;
}
